import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { filter, find } from 'lodash';
import { ProfileContext } from 'context';
import { sortByNoteType } from 'modules/Visit/components/VisitNotes/helpers';
import Information from 'modules/Information';
import * as selectors from '../../selectors';
import VisitNotes from './VisitNotes';
const VisitNotesMessenger = ({ selectedVisit, mode, onStoreNotes })=>{
    const profileContext = useContext(ProfileContext);
    const phiSet = useSelector(profileContext.selectors.phiSet);
    const notes = useSelector(profileContext.selectors.notes);
    const phiSetDocumentId = useSelector(profileContext.selectors.phiSetDocumentId);
    const activePatient = mode === 'HCP' ? useSelector(profileContext.selectors.activePatient) : useSelector(Information.selectors.information);
    const visits = useSelector(selectors.visits);
    const phisetVisitId = selectedVisit === null || selectedVisit === void 0 ? void 0 : selectedVisit.phisetVisitId;
    const filteredNotes = filter(notes, {
        phisetVisitId
    }).sort(sortByNoteType);
    const visit = find(visits, {
        phisetVisitId
    });
    const hcpProfile = selectedVisit.metadata.createdBy;
    const pwdProfile = {
        firstName: activePatient.firstName,
        lastName: activePatient.lastName,
        avatar: activePatient.avatar
    };
    return /*#__PURE__*/ _jsx(VisitNotes, {
        visit: visit,
        notes: filteredNotes,
        mode: mode,
        phiSet: phiSet,
        phiSetDocumentId: phiSetDocumentId,
        pwdAvatar: pwdProfile,
        hcpAvatar: hcpProfile,
        isReplyNoteFormWithActionButtons: true,
        onStoreNotes: onStoreNotes
    });
};
export default VisitNotesMessenger;
